// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"windy-rain"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 7H5.5C4.11929 7 3 8.11929 3 9.5C3 10.8807 4.11929 12 5.5 12H11M17 8H13C11.8954 8 11 7.10457 11 6C11 4.89543 11.8954 4 13 4H16M17 12H15M11.5 20H8C6.89543 20 6 19.1046 6 18C6 16.8954 6.89543 16 8 16M12 16H13M21 7.99609H21.0039V8H21V7.99609ZM21 11.9961H21.0039V12H21V11.9961ZM17 15.9961H17.0039V16H17V15.9961Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WindyRainIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'windy-rain',
    ref,
    icon: element,
  },
));

WindyRainIcon.displayName = 'WindyRainIcon';

export default WindyRainIcon;
